var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZksyncEraLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 729.32 137.91",
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m583.35,137.91h-31.72c-38.03,0-68.95-30.92-68.95-68.95S513.6,0,551.64,0s68.95,30.92,68.95,68.95v67.58h-27.58v-67.58c0-22.86-18.51-41.37-41.37-41.37s-41.37,18.51-41.37,41.37,18.51,41.37,41.37,41.37h31.72v27.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.52,136.53h-27.58v-67.58c0-38.03,30.92-68.95,68.95-68.95v27.58c-22.86,0-41.37,18.51-41.37,41.37v67.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.4,137.91c-38.03,0-68.95-30.92-68.95-68.95S265.37,0,303.4,0s68.95,30.92,68.95,68.95v13.79h-79.3v-27.58h49.32c-5.73-16.08-21.01-27.58-38.94-27.58-22.86,0-41.37,18.51-41.37,41.37s18.51,41.37,41.37,41.37c13.79,0,26.67-6.9,34.37-18.4l22.86,15.39c-12.77,19.09-34.15,30.59-57.27,30.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m729.32,27.58h-67.36v108.95h67.36V27.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.91 124.12 193.07 68.95 137.91 13.79 137.91 55.16 82.75 96.54 137.91 96.54 137.91 124.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.16 13.79 0 68.95 55.16 124.12 55.16 82.75 110.33 41.37 55.16 41.37 55.16 13.79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZksyncEraLogoLight);
export default __webpack_public_path__ + "static/media/zksync-era-logo-light.cab9eb0c700c235fcf00bb016a45dc0d.svg";
export { ForwardRef as ReactComponent };